import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M2490 6006 c-112 -23 -173 -90 -174 -191 0 -71 38 -133 117 -192 75
-54 143 -89 347 -178 404 -174 561 -293 605 -460 7 -28 10 -24 27 45 25 98 27
305 4 407 -34 153 -105 284 -183 333 -83 52 -324 166 -423 200 -52 17 -120 34
-150 36 -30 3 -68 6 -85 8 -16 2 -55 -2 -85 -8z"/>
<path d="M5915 5873 c-30 -29 -36 -61 -19 -94 20 -40 58 -54 106 -39 94 27 68
150 -31 150 -23 0 -46 -7 -56 -17z"/>
<path d="M3978 5840 c-57 -10 -132 -60 -155 -103 -22 -41 -22 -123 0 -164 26
-49 53 -71 152 -120 50 -25 100 -54 113 -66 72 -67 -45 -141 -138 -87 -81 47
-76 47 -124 4 -24 -21 -45 -44 -45 -50 -2 -18 41 -52 104 -81 116 -53 261 -31
333 51 39 44 46 69 40 146 -4 52 -9 65 -39 96 -35 36 -87 69 -149 94 -19 7
-52 24 -72 37 -48 30 -52 70 -11 103 33 26 87 22 138 -10 l31 -19 42 42 c23
24 42 47 42 52 0 19 -89 64 -146 74 -32 6 -60 10 -63 10 -3 -1 -27 -5 -53 -9z"/>
<path d="M2075 5659 c-5 -19 -10 -43 -11 -54 -9 -64 -16 -127 -21 -175 -2 -30
-10 -59 -16 -65 -12 -10 -33 -51 -59 -112 -7 -18 -16 -33 -20 -33 -4 0 -5 -7
-2 -15 6 -16 -15 -21 -32 -7 -5 4 1 -3 14 -14 33 -30 102 -65 113 -58 5 3 9 0
9 -6 0 -8 10 -10 28 -6 16 4 22 3 14 -2 -14 -10 38 -35 197 -96 91 -35 131
-45 101 -26 -8 5 -10 10 -4 10 6 0 21 -12 33 -26 17 -20 29 -25 49 -20 15 3
21 3 14 -1 -9 -3 2 -13 29 -24 23 -11 44 -17 47 -14 3 3 0 5 -6 5 -7 0 -12 5
-12 11 0 5 4 8 9 5 5 -3 11 3 14 13 3 11 -1 22 -8 24 -7 3 -15 18 -18 34 -3
16 -15 32 -29 38 -15 7 -25 21 -28 43 -3 18 -8 33 -12 32 -35 -1 -38 1 -38 40
0 29 -4 40 -15 40 -11 0 -15 11 -15 40 0 33 3 40 20 40 28 0 25 18 -5 26 -19
5 -25 13 -25 33 0 22 5 27 27 29 15 1 34 8 41 16 11 11 7 16 -27 30 -23 9 -49
16 -58 16 -24 0 -83 23 -83 32 0 12 13 9 34 -7 11 -8 29 -15 40 -15 15 0 6 9
-29 30 -56 33 -70 37 -61 15 7 -20 -8 -19 -25 1 -10 12 -10 17 0 23 9 6 5 13
-13 24 -29 20 -95 84 -129 128 l-24 31 -8 -33z m30 -29 c3 -5 1 -10 -4 -10 -6
0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m325 -240 c0 -5 -7 -7 -15 -4
-8 4 -15 8 -15 10 0 2 7 4 15 4 8 0 15 -4 15 -10z"/>
<path d="M4445 5642 c-55 -24 -85 -41 -85 -50 0 -4 15 -24 33 -45 l32 -38 45
20 c25 11 61 21 81 21 44 0 89 -32 89 -64 0 -22 -5 -23 -80 -29 -143 -11 -214
-58 -225 -149 -15 -119 128 -205 251 -149 23 10 45 24 48 30 12 19 26 12 26
-14 0 -24 3 -25 60 -25 50 0 60 3 60 18 1 9 1 91 0 182 -1 192 -13 232 -83
278 -35 23 -52 27 -126 29 -64 2 -96 -2 -126 -15z m195 -305 c0 -43 -22 -73
-65 -87 -47 -16 -89 4 -93 43 -6 51 27 72 121 76 36 1 37 0 37 -32z"/>
<path d="M4923 5652 c-23 -3 -23 -5 -23 -181 0 -194 6 -229 52 -277 62 -66
198 -72 264 -13 26 24 32 24 36 -3 3 -20 10 -23 55 -26 48 -3 53 -1 58 20 3
13 4 127 3 253 l-3 230 -70 0 -70 0 -2 -150 c-2 -82 -5 -160 -8 -172 -9 -37
-45 -63 -87 -63 -67 0 -72 15 -78 213 l-5 172 -50 0 c-27 1 -60 -1 -72 -3z"/>
<path d="M5548 5653 l-58 -4 0 -250 0 -250 73 3 72 3 5 150 c3 95 10 158 18
172 17 31 63 53 110 53 l40 0 5 58 c2 31 3 60 0 65 -2 4 -26 7 -53 7 -43 0
-54 -5 -89 -38 l-39 -37 -6 37 c-4 21 -10 37 -14 36 -4 -1 -33 -3 -64 -5z"/>
<path d="M5907 5653 c-4 -3 -7 -118 -7 -255 l0 -248 70 0 69 0 7 36 c5 26 0
455 -6 470 -1 5 -128 3 -133 -3z"/>
<path d="M2450 5363 c1 -5 9 -18 20 -31 14 -17 25 -22 40 -17 23 7 26 18 8 32
-17 14 -68 25 -68 16z"/>
<path d="M2588 5333 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2580 5300 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M1800 5090 c0 -5 5 -10 11 -10 7 0 9 -10 5 -25 -4 -14 -2 -34 4 -45
7 -13 7 -20 1 -20 -6 0 -13 11 -17 25 -3 14 -10 25 -15 25 -18 0 51 -179 100
-258 95 -155 241 -261 463 -335 177 -60 312 -58 383 5 70 61 53 138 -46 214
-70 54 -138 86 -354 166 -164 61 -416 176 -446 204 -11 10 -26 13 -38 9 -13
-4 -21 -2 -21 5 0 6 5 8 10 5 22 -14 8 14 -15 29 -14 9 -25 12 -25 6z"/>
<path d="M2575 4940 c-8 -13 9 -20 24 -11 10 6 9 10 -3 14 -8 3 -18 2 -21 -3z"/>
<path d="M2600 4890 c32 -24 100 -51 100 -40 0 5 -19 15 -42 21 -24 6 -37 14
-30 16 22 8 12 18 -21 20 l-32 2 25 -19z"/>
<path d="M3782 4888 c-16 -16 -17 -520 -2 -549 11 -19 47 -19 2343 -19 1801 0
2336 3 2345 12 17 17 17 539 0 556 -17 17 -4669 17 -4686 0z m3156 -109 c4
-31 -19 -44 -49 -29 -22 12 -24 31 -7 48 21 21 53 10 56 -19z m-2276 -134 c12
-36 25 -65 28 -65 3 0 14 28 25 63 17 54 23 62 45 62 21 0 28 -8 45 -57 11
-31 23 -59 27 -63 3 -3 16 23 28 59 20 61 24 66 51 66 35 0 35 -5 5 -83 -13
-34 -30 -80 -39 -102 -11 -30 -21 -41 -39 -43 -21 -3 -28 4 -46 49 -12 28 -22
58 -22 65 0 8 -4 14 -10 14 -5 0 -10 -6 -10 -14 0 -7 -10 -36 -21 -65 -18 -41
-26 -51 -46 -51 -13 0 -26 7 -30 18 -3 9 -21 56 -39 104 -19 48 -34 92 -34 98
0 5 13 10 29 10 27 0 31 -5 53 -65z m393 -2 c11 -35 23 -63 27 -63 3 0 16 29
28 65 18 56 25 65 45 65 21 0 27 -9 46 -70 13 -38 25 -67 27 -65 3 3 14 33 26
67 19 56 24 63 49 66 28 3 29 2 22 -27 -4 -18 -21 -68 -39 -114 -27 -71 -35
-82 -58 -85 -20 -2 -27 2 -32 21 -3 14 -14 44 -24 68 l-19 43 -24 -67 c-21
-59 -27 -67 -49 -67 -23 0 -29 10 -63 103 -45 123 -45 129 -9 125 24 -3 29
-11 47 -65z m399 -8 l22 -70 26 70 c22 59 29 70 49 70 19 0 26 -10 43 -62 12
-35 24 -63 27 -63 3 0 14 28 25 63 19 57 22 62 50 62 35 0 35 3 -13 -127 -33
-91 -37 -98 -62 -98 -24 0 -29 6 -46 58 -18 57 -35 87 -35 64 0 -6 -9 -36 -21
-67 -19 -50 -24 -56 -47 -53 -22 3 -30 15 -63 103 -21 55 -38 106 -39 113 0 9
10 12 31 10 29 -3 33 -8 53 -73z m581 63 c44 -20 23 -64 -22 -47 -26 10 -46 4
-41 -12 2 -5 23 -19 48 -31 38 -19 45 -28 48 -56 4 -41 -10 -59 -54 -71 -35
-10 -98 1 -109 19 -11 17 19 50 35 39 20 -12 73 -12 68 1 -1 5 -23 20 -48 32
-47 24 -58 46 -46 92 10 40 71 57 121 34z m259 -9 c25 -19 26 -25 26 -114 l0
-94 -52 -1 c-29 0 -63 -1 -76 -1 -34 -1 -62 29 -62 66 0 42 28 66 85 73 59 6
53 27 -8 27 -101 0 -77 63 24 64 22 1 46 -7 63 -20z m166 -52 c0 -83 13 -111
51 -105 23 3 24 6 27 91 l3 87 29 0 30 0 0 -95 c0 -82 -3 -97 -21 -113 -42
-40 -126 -37 -159 6 -17 20 -20 40 -20 113 l0 89 30 0 30 0 0 -73z m280 57 c0
-14 2 -14 22 0 36 26 60 21 56 -11 -2 -20 -9 -29 -25 -31 -36 -5 -53 -40 -53
-109 l0 -63 -30 0 -30 0 0 115 0 115 30 0 c20 0 30 -5 30 -16z m200 -99 l0
-115 -30 0 -30 0 0 115 0 115 30 0 30 0 0 -115z m278 101 c8 -5 18 -4 25 3 17
17 69 13 96 -8 23 -17 25 -28 29 -115 l4 -96 -31 0 c-34 0 -37 10 -32 92 3 52
-14 80 -47 76 -27 -3 -27 -4 -30 -85 l-3 -83 -34 0 -35 0 0 109 c0 78 4 111
13 114 16 5 29 3 45 -7z m370 2 c8 -8 15 -8 24 -1 7 6 21 10 31 10 15 0 17
-13 17 -128 0 -119 -2 -130 -23 -154 -29 -34 -96 -44 -150 -22 -39 17 -42 23
-28 46 8 13 15 13 50 1 35 -11 43 -11 66 4 32 21 35 51 3 39 -57 -19 -120 5
-139 55 -29 75 24 162 99 162 21 0 43 -5 50 -12z m-1758 -163 c6 -8 9 -23 5
-35 -5 -17 -13 -20 -38 -18 -21 2 -33 9 -35 21 -8 39 42 63 68 32z m1250 0
c20 -24 8 -50 -24 -50 -39 0 -58 31 -32 51 25 18 40 18 56 -1z"/>
<path d="M6197 4563 c-24 -24 22 -55 48 -33 25 20 18 40 -13 40 -16 0 -32 -3
-35 -7z"/>
<path d="M7511 4641 c-18 -11 -19 -65 -1 -85 15 -19 50 -21 74 -3 21 15 25 75
5 88 -18 11 -60 11 -78 0z"/>
<path d="M2715 4870 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2710 4831 c0 -5 9 -11 21 -14 16 -4 18 -3 8 9 -13 16 -29 19 -29 5z"/>
<path d="M2770 4790 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2825 4750 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2855 4720 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2953 4504 c-1 -103 -54 -191 -154 -256 -27 -17 -49 -33 -49 -35 0
-12 166 54 208 83 29 19 31 23 15 27 -11 3 -8 5 11 6 34 1 127 52 108 59 -7 2
-22 -4 -33 -14 -10 -9 -22 -14 -27 -9 -4 4 -1 10 6 12 9 4 8 13 -6 36 -11 18
-23 45 -26 61 -5 22 -10 26 -19 17 -19 -19 -26 -12 -30 32 -3 31 -4 26 -4 -19z
m77 -114 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10
-10z m-30 -20 c13 -13 15 -20 7 -20 -14 0 -37 20 -37 32 0 13 9 9 30 -12z"/>
</g>
</svg>





    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
